import { render } from "./VideoUploadPopUpComponent.vue?vue&type=template&id=16f3af72&scoped=true"
import script from "./VideoUploadPopUpComponent.vue?vue&type=script&lang=js"
export * from "./VideoUploadPopUpComponent.vue?vue&type=script&lang=js"

import "./VideoUploadPopUpComponent.vue?vue&type=style&index=0&id=16f3af72&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-16f3af72"

export default script